import { Link, Outlet } from '@tanstack/react-router';

import { ResizableSplit } from '../components/ui/split.js';

const NAV = [
  {
    group: 'Workspace',
    items: [
      { to: '/settings/general', icon: 'ti-settings', label: 'Общие' },
      { to: '/settings/team', icon: 'ti-users', label: 'Команда' },
      { to: '/settings/roles', icon: 'ti-shield', label: 'Роли и права' },
      { to: '/settings/templates', icon: 'ti-template', label: 'Шаблоны' },
      { to: '/settings/sla', icon: 'ti-clock', label: 'SLA' },
    ],
  },
  {
    group: 'Каналы',
    items: [
      { to: '/settings/stores', icon: 'ti-building-store', label: 'Магазины' },
      { to: '/settings/channels', icon: 'ti-plug', label: 'Каналы связи' },
      { to: '/settings/data-connectors', icon: 'ti-database', label: 'Коннекторы данных' },
    ],
  },
  {
    group: 'Безопасность',
    items: [
      { to: '/settings/security', icon: 'ti-lock', label: 'Безопасность' },
      { to: '/settings/audit-log', icon: 'ti-history', label: 'Audit Log' },
      { to: '/settings/gdpr', icon: 'ti-file-shield', label: 'GDPR' },
    ],
  },
  {
    group: 'Биллинг',
    items: [
      { to: '/settings/billing', icon: 'ti-credit-card', label: 'Подписка' },
      { to: '/settings/license', icon: 'ti-key', label: 'Лицензия' },
    ],
  },
  {
    group: 'Разработчикам',
    items: [
      { to: '/settings/api-keys', icon: 'ti-key', label: 'API-ключи' },
      { to: '/settings/webhooks', icon: 'ti-webhook', label: 'Webhooks' },
    ],
  },
];

export function SettingsLayout(): JSX.Element {
  return (
    <ResizableSplit id="settings-cols" direction="row" sizes={[220, 0]} mins={[180, 480]}>
      <aside className="inbx-settings__nav" style={{ height: '100%' }}>
        {NAV.map((g) => (
          <div key={g.group}>
            <div className="inbx-settings__nav-group">{g.group}</div>
            {g.items.map((it) => (
              <Link
                key={it.to}
                to={it.to}
                className="inbx-settings__nav-item"
                activeProps={{ className: 'inbx-settings__nav-item is-active' }}
              >
                <i className={it.icon} /> {it.label}
              </Link>
            ))}
          </div>
        ))}
      </aside>
      <main className="inbx-settings__main" style={{ height: '100%' }}>
        <Outlet />
      </main>
    </ResizableSplit>
  );
}
